// ============================================================================
// Game parallax driver
//
// The panning background layers are sized/positioned in CSS and were animated
// with `animation: s-game-bg-pan linear infinite`. On iOS Safari that CSS
// animation drops the composited layer for a single frame at every iteration
// boundary — a visible flicker once per loop (measured: every 8–10s the layer
// disappears for one frame, exposing whatever is behind it). GPU-promotion
// hacks (translate3d / will-change / backface-visibility) do not fix it.
//
// This driver replaces the CSS loop with a continuous requestAnimationFrame
// transform. There is no animation iteration boundary, so there is no dropout.
// It reads each layer's CSS `animation-name` + `animation-duration`, so it
// adapts to every theme's per-layer speeds without hardcoding anything; the
// CSS animation stays as a no-JS fallback.
// ============================================================================

(function () {
    const PAN = 's-game-bg-pan';            // parallax pan: translateX 0 → -50% of width, looped
    const CROSS = 's-game-vehicle-cross';   // single sprite crossing: translateX -100% → 100vw

    const bg = document.querySelector('.s-game__bg');
    if (!bg) return;

    const layers = Array.from(bg.querySelectorAll('.s-game__bg-layer'));
    if (!layers.length) return;

    const items = [];
    layers.forEach((el) => {
        const cs = getComputedStyle(el);
        const name = (cs.animationName || '').trim();
        const durMs = (parseFloat(cs.animationDuration) || 0) * 1000;
        if (durMs <= 0 || (name !== PAN && name !== CROSS)) return;

        el.style.animation = 'none'; // hand the transform over from CSS to rAF
        items.push({ el, name, durMs, offset: 0, span: 0, start: 0, end: 0, speed: 0 });
    });
    if (!items.length) return;

    function measure() {
        const vw = window.innerWidth;
        items.forEach((it) => {
            const w = it.el.offsetWidth;
            if (it.name === PAN) {
                // CSS translateX(-50%) of the 2-tile wrapper == one tile == w/2.
                // Both tiles are identical, so wrapping by w/2 is seamless.
                it.span = w / 2;
                it.speed = it.span / it.durMs; // px/ms (moves negative)
                if (it.offset < -it.span || it.offset > 0) it.offset = 0;
            } else {
                // CROSS: -100% (= -w) → +100vw. Sprite is fully off-screen at both
                // ends, so the reset is never visible.
                it.start = -w;
                it.end = vw;
                it.span = w + vw;
                it.speed = it.span / it.durMs; // px/ms (moves positive)
                if (it.offset < it.start || it.offset > it.end) it.offset = it.start;
            }
        });
    }

    measure();
    window.addEventListener('resize', measure);

    let last = performance.now();
    let running = true;

    function frame(now) {
        if (!running) return;
        const dt = Math.min(now - last, 50); // clamp gaps (backgrounded tab)
        last = now;
        for (let i = 0; i < items.length; i++) {
            const it = items[i];
            if (it.name === PAN) {
                it.offset -= it.speed * dt;
                if (it.offset <= -it.span) it.offset += it.span;
            } else {
                it.offset += it.speed * dt;
                if (it.offset >= it.end) it.offset = it.start;
            }
            it.el.style.transform = 'translate3d(' + it.offset.toFixed(2) + 'px, 0, 0)';
        }
        requestAnimationFrame(frame);
    }

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            running = false;
        } else if (!running) {
            running = true;
            last = performance.now();
            requestAnimationFrame(frame);
        }
    });

    requestAnimationFrame(frame);
}());
